import { useEffect } from 'react';

import { hasStorageAvailable } from '@klv/shared/utils/storage';

const getLastViewedAcademyContent = () => {
  const fallback = '';

  try {
    if (hasStorageAvailable('sessionStorage')) {
      const storedLastViewedAcademyContent = sessionStorage.getItem('lastViewedAcademyContent');

      if (storedLastViewedAcademyContent) {
        const parsed = JSON.parse(storedLastViewedAcademyContent);

        if (parsed) {
          return parsed;
        }
      }
    }

    return fallback;
  } catch (error) {
    console.warn('Error parsing lastViewedAcademyContent from sessionStorage');
    return fallback;
  }
};

export const PostLoginRedirect = () => {

  useEffect(() => {
    if (
      hasStorageAvailable('sessionStorage')
    ) {
      const lastViewedAcademyContent = getLastViewedAcademyContent();
      
      if (lastViewedAcademyContent) {
        sessionStorage.removeItem('lastViewedAcademyContent');
        const url = new URL(window.location.href);
        url.pathname = lastViewedAcademyContent;
        window.location.href = url.toString();
      }
    }
  }, []);

  return null;

};
